var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate name signup-prompt"},[_c('Conversation',{on:{"scroll":function($event){return _vm.$emit('scroll')},"done":function($event){return _vm.$emit('done')}},model:{value:(_vm.conversation),callback:function ($$v) {_vm.conversation=$$v},expression:"conversation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }